import { render } from "./WorkflowList.vue?vue&type=template&id=547648c2&ts=true"
import script from "./WorkflowList.vue?vue&type=script&lang=ts"
export * from "./WorkflowList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__